import * as React from "react";
import {cx} from "emotion";

import "./service-level-sub-section.scss";

import {cs}               from "@Common/react/chain-services";
import {Static2}          from "@Common/react/static-2";
import {ErrorHighlighter} from "@Common/ui-components/light/error-highlighter";
import {scrollIntoView}   from "@Common/ui-components/light/scroll-into-view";
import {isSuperSmall}     from "@Common/utils/math/is-super-small";

import {isFreightServiceLevel}  from "../../../../customize/steps/checkout/shipping-section/common/is-freight-service-level";
import {formatServiceLevelName} from "../../../../customize/steps/checkout/shipping-section/common/service-level/format-service-level-name";
import {ShippingRateModal}      from "../../../../customize/steps/checkout/shipping-section/common/service-level/shipping-rate-modal/shipping-rate-modal";
import {CheckShowPricing}       from "../../../check-show-pricing";
import {MoneySpan}              from "../../../form/money-span/money-span";
import {SubsxFree}              from "../../../subsx-free/subsx-free";
import {SubSectionBody}         from "../common/sub-section-body/sub-section-body";

export const ServiceLevelSubSection = ({next}) => cs(

    ["eh", (_, next) => ErrorHighlighter({next})],
    ["domRef", (_, next) => Static2({next})],
    ({eh, domRef}) => next({
        highlightErrors: () => {
            eh.start();
            scrollIntoView(domRef.get());
        },
        render: (
            {
                apiError=undefined,
                shippingItemsCount=undefined,
                selectedServiceLevel,
                getServiceLevels,
                estimatedDeliveryMessage=undefined,
                shippingCharge,
                errors=undefined,
                selectLevelDisclaimer=undefined,
                onSelect,
            }
        ) => cs(
            ["shippingRateModal", ({}, next) => ShippingRateModal({
                shippingItemsCount,
                next
            })],

            ({}, next) => (
                <div className="service-level-sub-section-2ql">
                    <div className="header" xd-qa-type="label" xd-qa-name="Service Level">
                        Select Service Level
                    </div>
                    {next()}
                </div>
            ),
            ({}, next) => apiError ? (
                <div className={cx("error", eh.css)} xd-qa-type="label" xd-qa-name="Service Level Error" ref={domRef.set}>
                    {apiError}
                </div>
            ) : (
                next()
            ),
            ({}, next) => selectedServiceLevel && next(),
            ({shippingRateModal}) => SubSectionBody({
                content: (
                    <div className="details-3oo">
                        <div className="line1">
                            <div className="name" xd-qa-type="label" xd-qa-name={selectedServiceLevel}>
                                {selectedServiceLevel ? formatServiceLevelName(selectedServiceLevel) : "..."}
                            </div>

                            {cs(
                                ({}, next) => !isFreightServiceLevel(selectedServiceLevel) && next(),
                                ({}, next) => CheckShowPricing({next}),
                                () => (
                                    shippingCharge.loading ? (
                                        <i className="fa fa-spinner fa-pulse"/>
                                    ) : isSuperSmall(shippingCharge.value??0) ? (
                                        SubsxFree({
                                            xdQaName: "Subsx Shipping Amount"
                                        })
                                    ) : (
                                        MoneySpan({
                                            freeBadge: false,
                                            value: shippingCharge.value,
                                            xdQaName: "Shipping Amount"
                                        })
                                    )
                                )
                            )}

                            <div className="actions">
                                <a
                                    xd-qa-type="link"
                                    xd-qa-name="Edit Service Levels"
                                    onClick={() => shippingRateModal.show({
                                        fetch: getServiceLevels,
                                        selected: selectedServiceLevel,
                                        disclaimer: selectLevelDisclaimer,
                                        onSelect,
                                    })}
                                >Edit</a>
                            </div>
                        </div>

                        {estimatedDeliveryMessage && (
                            <div
                                className="estimated-delivery-date"
                                xd-qa-type="label"
                                xd-qa-name="Estimated Delivery Date"
                            >
                                Estimated Arrival: {estimatedDeliveryMessage}
                            </div>
                        )}

                        {!!errors?.length && (
                            <div className="errors">
                                {errors?.map((e, i) => (
                                    <div
                                        key={i}
                                        className="ship-error"
                                        xd-qa-type="label"
                                        xd-qa-name={e.name}
                                    >
                                        {e.message}
                                    </div>
                                ))}
                            </div>
                        )}
                    </div>
                ),
                xdQaName: selectedServiceLevel
            })
        ),
    })
);
